import React, { Component } from 'react';
import Header from './../common/Header';
import { Link } from 'react-router';
import { Card, Button, CardBody, CardTitle, CardText, CardImg } from 'reactstrap';

class Products extends Component {
    render() {
        return (
            <div style={{ overflowX: 'hidden', overflowY: 'hidden' }}>
                <Header />
                <div className="row">
                    <div className="col-1" />
                    <div className="col-10">
                        <div className="row" style={{ paddingTop: 20, paddingLeft: 15 }}>
                            <div style={{ paddingTop: 5 }}>
                                <h6 style={{ color: '#000', fontFamily: 'Source Sans Pro-SemiBold' }}>
                                    Showing List of Products
                                </h6>
                            </div>
                            <div style={{ paddingLeft: 20 }}>
                                <Link to="/add_products">
                                    <Button
                                        style={styles.articleButtonStyle}
                                    >
                                        <span style={{ fontSize: 14, fontFamily: 'Source Sans Pro-SemiBold' }}>
                                            Add Product
                                        </span>
                                    </Button>
                                </Link>
                            </div>
                        </div>
                        <div className="row" style={{ paddingTop: 10, paddingBottom: 10 }}>
                            <div className="col-xs-6 col-sm-4" style={{ paddingTop: 15 }}>
                                <Card style={{ boxShadow: `0px 5px 15px 0px rgba(0,0,0,0.05)` }}>
                                    <CardImg top width="100%" height="200px" src="https://placeholdit.imgix.net/~text?txtsize=33&txt=318%C3%97180&w=318&h=180" alt="Card image cap" />
                                    <CardBody style={{ height: '150px' }}>
                                        <CardTitle>Card Title</CardTitle>
                                        <CardText>This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</CardText>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </div>
                    <div className="col-1" />
                </div>
            </div>
        );
    }
}

const styles = {
    articleButtonStyle: {
        width: 100,
        backgroundColor: '#40b508',
        borderWidth: 0,
        height: 32,
        padding: '1px 5px',
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    },
    likeTextStyle: {
        color: '#1FBE4D',
        fontSize: 18
    },
    dislikeTextStyle: {
        color: '#F20000',
        fontSize: 18
    }
};

export default Products;



// WEBPACK FOOTER //
// ./src/components/Products/Products.js